/**
 * The newest Paperclip version documented on the public site.
 *
 * Keep this at the CLI version served by this container. The container build
 * fails when this value does not match the wheel that it will deploy.
 */
export const PAPERCLIP_DOCUMENTED_VERSION = "0.8.16";
